import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostCommentsAppendSucceed, EGetPostCommentsActionType } from './types';
import { ICommentList } from '../../../types/commentList';

export const getPostCommentsAppendSucceed: (data: ICommentList) => TGetPostCommentsAppendSucceed = actionGenerator<
  EGetPostCommentsActionType.AppendSucceed,
  ICommentList
>(EGetPostCommentsActionType.AppendSucceed);
